module.exports = __webpack_public_path__ + "static/img/11.28d97d99.png";